<template>
  <div>
    <div class="mb-4">
      В работе нашей клиники мы стараемся многие процессы автоматизировать при помощи цифровизации.
      Приложение МедТочка позволило нам:
    </div>
    <ul class="mb-4 ml-6">
      <li>
        получить ещё больший контакт с нашими пациентами и удобно оповещать их о повторном приёме;
      </li>
      <li>
        собирать обратную связь от пациентов через своевременное уведомление об отзыве.
        Так мы понимаем, насколько качественно оказали услугу;
      </li>
      <li>
        загружать электронное заключение и постепенно отойти от «бумаги».
      </li>
    </ul>
    <div class="mb-4">
      Большинство наших пациентов положительно реагируют на приложение, в котором они могут видеть время
      посещений услуг и уведомления о них, хранить документы в электронном виде, находить для себя
      подходящего врача, ориентируясь на отзывы.
    </div>
    <div>
      Мы довольны работой приложения МедТочка и будем рады новым обновлениям.
    </div>
  </div>
</template>
